
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton } from '@/components'
import { routerPush } from '@/services/routing'

export default Vue.extend({
  name: 'RemoveComputersModal',
  components: {
    CustomTextModal,
    RButton,
  },
  methods: {
    handleClick() {
      routerPush(this.$router, '/select-plan')
    },
  },
})
